'use strict';

/**
 * @ngdoc function
 * @name courseApp.controller:CourseController
 * @description
 * # CourseController
 * Controller of the courseApp
 */
angular.module('courseApp')
    .controller('CourseController', function (CourseService, ActCourseService, CourseHotelService) {
        var vm = this;
        vm.courseList = [];
        vm.courseHotelList = [];
        CourseService.query().$promise.then(function (data) {
            angular.forEach(data, function (course) {
                vm.courseList.push(course);
            });
        });

        vm.loadHotelList = function () {
            vm.courseHotelList = [];
            CourseHotelService.query({ course: vm.selectedCourse.id }).$promise.then(function (data) {
                angular.forEach(data, function (courseHotel) {
                    vm.courseHotelList.push(courseHotel);
                });
            });
        };

        vm.onSelectCallback = function () {
            ActCourseService.setActCourse(vm.selectedCourse);
            vm.loadHotelList();
        };

        vm.selectedCourse = ActCourseService.getActCourse();
        if (angular.isDefined(vm.selectedCourse)) {
            vm.loadHotelList();
        }
    });
